import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  InputLabel,
} from "@mui/material";

const SelectInputField = ({
  label,
  required,
  value,
  onChange,
   options,
  id,
  style = {},
  htmlFor,
  error,
  helperText,
  inputProps,
  multiple,
  menuProps, // optional MenuProps overrides
  errorColor, // themed error color for helper text
  themeMode = 'light', // new: 'light' | 'dark'
}) => {
  // Derive themed colors (keep neutral defaults if style already supplies)
  const isDark = themeMode === 'dark';
  const palette = {
    text: style.color || (isDark ? '#FFFFFF' : '#1A1A1A'),
    label: isDark ? '#FFFFFF' : '#3C3C3C',
    bg: isDark ? '#2F2F2F' : '#FFFFFF',
    border: isDark ? '#555555' : '#D0D6DA',
    menuBg: isDark ? '#2F2F2F' : '#FFFFFF',
    menuItemHover: isDark ? '#3A3A3A' : '#F2F6F9',
  };
  const mergedRootStyle = {
    ...style,
    color: palette.text,
  };
  const selectStyle = {
    color: palette.text,
    background: palette.bg,
    border: `1px solid ${palette.border}`,
    borderRadius: 6,
    padding: '4px 8px',
  };
  const effectiveMenuProps = menuProps || {
    PaperProps: {
      style: {
        maxHeight: 250,
        overflowY: 'auto',
        background: palette.menuBg,
        color: palette.text,
        border: `1px solid ${palette.border}`,
      }
    },
    MenuListProps: {
      sx: {
        '& .MuiMenuItem-root': {
          fontSize: 14,
        },
        '& .MuiMenuItem-root:hover': {
          background: palette.menuItemHover,
        },
      }
    }
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <div style={{ display: 'flex', textAlign: 'start', marginTop: 10, fontSize: 18, fontWeight: 400, color: palette.label }}>
        <label htmlFor={htmlFor}>
          {label}
          {required && (
            <span className="mandatory" style={{ color: 'red', marginLeft: 5 }}>*</span>
          )}
        </label>
      </div>
      <div style={{ width: '100%' }}>
        <FormControl style={mergedRootStyle} variant="standard" error={error} fullWidth>
          <Select
            id={id}
            value={value}
            multiple={multiple}
            onChange={onChange}
            inputProps={inputProps}
            style={selectStyle}
            MenuProps={effectiveMenuProps}
          >
            {options?.map(option => (
              <MenuItem
                key={option.value}
                value={option.value}
                sx={{
                  fontSize: 14,
                  '&:hover': { background: palette.menuItemHover },
                  background: palette.menuBg,
                  color: palette.text,
                }}
              >
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {helperText && (
            <FormHelperText style={errorColor ? { color: errorColor } : { color: palette.label }}>
              {helperText}
            </FormHelperText>
          )}
        </FormControl>
      </div>
    </div>
      );
};
export default SelectInputField;